export enum EventsEnum {
  CLICK = 'oss_click',
  DP_NORESULTS = 'oss_no_result_dp',
  DP_PROFILE_SEARCH = 'oss_profile_search_dp',
  DP_REDIRECT = 'oss_redirect_dp',
  DP_SEARCH = 'oss_search_dp',
  FF_REDIRECT = 'oss_redirect_fo',
  FF_SEARCH = 'oss_search_fo',
  HO_NORESULTS = 'oss_no_result_ho',
  HO_PROFILE_SEARCH = 'oss_profile_search_ho',
  HO_REDIRECT = 'oss_redirect_ho',
  HO_SEARCH = 'oss_search_ho',
  HOTEL_IMAGES = 'oss_hotel_image',
  RANKING = 'oss_ranking',
}
